import { AbstractControl, FormGroup, ValidatorFn } from "@angular/forms";



export function EditGridRequiredValidator(control: AbstractControl): { [key: string]: any } | null {
    if (control.value && control.value.length <= 0) {
        return { 'invalid': true };
    }
    return null;
}

export function EvidencesRequiredValidator(control: AbstractControl): { [key: string]: any } | null{
    const evidences = control.value;

    let hasError = false;
    if (!evidences?.length || !evidences.some(q => q.selected)) {
        hasError = true;
    }
    return hasError ? { 'evidencesInvalid': true } : null;
}

export function AnswerValidator(): ValidatorFn {
    return (group: FormGroup) => {
        const question = group.value.question?.value;
        const answer = group.value.reviewerEvaluation;

        let hasError = false;
        if (question && answer) {
            hasError = (+answer || 0) * (question?.weight || 1) < question?.averageToPass;
        }
        return hasError ? { 'answerInvalid': true } : null;
    };
}

export function MasarAnswerValidator(): ValidatorFn {
    return (group: FormGroup) => {
        const subAnswers = group.value.subAnswers;
        const averageToPass = group.value.question?.value?.averageToPass;
        const notApply = group.value.notApply;

        const evaluationsAnswerd = subAnswers.filter(q => !!q.score);
        group.value.reviewerEvaluation = (evaluationsAnswerd.reduce((a, b) => a + +b.score * (b.evaluationItem.weight || 1), 0) / evaluationsAnswerd.length);

        let hasError = false;
        if (!notApply) {
            if (subAnswers.some(q => q.hasError)) hasError = true;
            else hasError = (group.value.reviewerEvaluation || 0) < averageToPass;
        }

        return hasError ? { 'masarAnswerInvalid': true } : null;
    };
}

export function MasarSubAnswerValidator(): ValidatorFn {
    return (group: FormGroup) => {
        const evaluationItem = group.value.evaluationItem;
        const answer = group.value.score;

        let hasError = answer == null || answer == undefined;
        if (evaluationItem && !!answer) {
            hasError = (+answer || 0) * (evaluationItem?.weight || 1) < evaluationItem?.averageToPass;
            group.value.hasError = hasError;
        }
        return hasError ? { 'masarSubAnswerInvalid': true } : null;
    };
}